import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../styles/csspages/Signup.css';

const Signup = () => {
  const [formData, setFormData] = useState({name: "", username:"", email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const api = process.env.REACT_APP_API_URL;


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${api}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/login");
      } else {
        setError(data.message || "Signup failed");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h2 className="signup-title">Sign Up</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
        <input 
            type="name" 
            name="name" 
            placeholder="name" 
            value={formData.name} 
            onChange={handleChange} 
            required 
          /><input 
          type="username" 
          name="username" 
          placeholder="Username" 
          value={formData.username} 
          onChange={handleChange} 
          required 
        />
          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            value={formData.email} 
            onChange={handleChange} 
            required 
          />
          <input 
            type="password" 
            name="password" 
            placeholder="Password" 
            value={formData.password} 
            onChange={handleChange} 
            required 
          />
          <button type="submit">Sign Up</button>
          <p>already have account? <Link to={('/login')}>login your account</Link></p>
        </form>
      </div>
    </div>
  );
};

export default Signup;
